/* eslint-disable react/button-has-type */
import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export type RecentSearchesProps = {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    showClearAll: boolean
    text: any
    children?: any
    clear: () => void
}

export const EnrichRecentSearches = memo(({templating, showClearAll, text, children, clear}: RecentSearchesProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    const templateProps = {
        templating,
        showClearAll,
        text,
        clear,
    }
    return (
        <Suspense>
            <ComponentName {...templateProps}>{children}</ComponentName>
        </Suspense>
    )
})
EnrichRecentSearches.displayName = "RecentSearches"

export default connect(EnrichRecentSearches)
